import React, { useRef, FC, useMemo, useState } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';

import { AppLayoutTop, AppCard } from '../../../../components/appComponents';
import $createStore from '../../../../utils/create-store-instance';
import { CashItemDeleteModal, ModalReportExcel } from './components';
import { useHistory } from 'react-router';
import { useGetCashFlowTotalQuery } from 'bus/cash';
import { onExporting } from 'utils/exportingExcel';
import { MONEY_FORMAT } from 'constants/formats';
import { Template } from 'devextreme-react';
import { CashTotals } from 'pages/Cash/components';

const CashFlow: FC = () => {
  const history = useHistory();

  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [modalIsVisibleReport, setModalIsVisibleReport] = useState(false);
  const [cashFlowId, setCashFlowId] = useState<number | null>(null);

  const { refetch } = useGetCashFlowTotalQuery(undefined, { refetchOnMountOrArgChange: true });

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/CashFlow', 'id');
  }, []);

  const requestCashFlowDocumentKinds = useMemo(() => {
    return $createStore('/v1/CashFlow/cashFlowDocumentKinds', 'id');
  }, []);
  const requestCashFlowAccounts = useMemo(() => {
    return $createStore('/v1/CashFlow/cashFlowAccounts', 'id');
  }, []);
  const requestCashFlowItemTypes = useMemo(() => {
    return $createStore('/v1/cashFlow/cashFlowTypes', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    refGrid.current?.instance.refresh();
    refetch();
  };

  const goToDetailHandler = ({ data }: any) => history.push(`/cash-flow/${data.id}`);

  const downloadExcel = () => setModalIsVisibleReport(true);

  return (
    <div className="container-dev">
      {modalIsVisibleDelete && (
        <CashItemDeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          id={cashFlowId}
        />
      )}

      <ModalReportExcel
        changeVisible={setModalIsVisibleReport}
        visible={modalIsVisibleReport}
      />

      <AppLayoutTop title="Движения по кассе">
        <Button
          width={120}
          text="Создать"
          type="default"
          onClick={() => history.push('/cash-flow-add')}
        />
      </AppLayoutTop>

      <CashTotals />

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onRowDblClick={goToDetailHandler}
          //rowTemplate={(data) => <RowTemplate data={data} />}
          onRowPrepared={(e) => {
            if (e.rowType === 'data' && e.data.isColoredRow ) {
              //@ts-ignore
              e.rowElement.style.backgroundColor = '#ffc5c5';
            }
          }}
          onExporting={onExporting}
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'excel'
            });
          }}
        >
          <Template name="excel">
            <Button
              icon="export"
              onClick={downloadExcel}
              text=""
              hint="Отчет"
            />
          </Template>
          <Export enabled={true} />
          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey="cashFlow"
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="date" caption="Дата" dataType="date" width={150} />
          <Column dataField="documentKind" caption="Вид документа">
            <Lookup
              dataSource={requestCashFlowDocumentKinds}
              valueExpr="id"
              displayExpr="name"
            />
          </Column>
          <Column dataField="cashFlowAccount" caption="Статья списания">
            <Lookup
              dataSource={requestCashFlowAccounts}
              valueExpr="id"
              displayExpr="name"
            />
          </Column>

          <Column dataField="cashFlowType" caption="Тип">
            <Lookup
              dataSource={requestCashFlowItemTypes}
              valueExpr="id"
              displayExpr="name"
            />
          </Column>

          <Column dataField="sum" caption="Сумма" format={MONEY_FORMAT} />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => goToDetailHandler(data)}
                />
                <Button
                  icon="trash"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setCashFlowId(data.data.id);
                    setModalIsVisibleDelete(true);
                  }}
                />
              </>
            )}
          />
          <Paging defaultPageSize={15} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={[15, 30, 50, 100]}
          />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default CashFlow;
